"use strict";
/** Схемы вложений, версий активов и проверки материалов. */
Object.defineProperty(exports, "__esModule", { value: true });
exports.createReviewSchema = exports.updateAssetVersionSchema = exports.createAssetVersionSchema = exports.attachmentMetadataSchema = void 0;
exports.fileExtension = fileExtension;
exports.checkAttachmentMetadata = checkAttachmentMetadata;
const contracts_1 = require("@project-os/contracts");
const zod_1 = require("zod");
const common_1 = require("./common");
// --- Вложения ------------------------------------------------------------
/**
 * Метаданные загружаемого файла.
 *
 * Проверяется и MIME-тип, и расширение: один только MIME приходит от клиента
 * и подделывается тривиально, а одно только расширение ничего не говорит о
 * содержимом. Фактическая сигнатура проверяется на сервере — здесь для неё
 * нет данных.
 */
exports.attachmentMetadataSchema = zod_1.z.object({
    filename: zod_1.z
        .string()
        .trim()
        .min(1, 'Имя файла обязательно')
        .max(500, 'Имя файла слишком длинное')
        // Разделители пути и управляющие символы в имени файла недопустимы:
        // имя подставляется в заголовок ответа при скачивании.
        .refine((value) => !/[/\\]/.test(value), 'В имени файла не должно быть символов / и \\')
        // eslint-disable-next-line no-control-regex
        .refine((value) => !/[\u0000-\u001f\u007f]/.test(value), 'Недопустимые символы в имени файла')
        .refine((value) => value !== '.' && value !== '..', 'Некорректное имя файла'),
    mimeType: zod_1.z.string().trim().min(1).max(200),
    sizeBytes: zod_1.z.number().int().positive(),
});
/** Расширение файла в нижнем регистре, включая точку. Пустая строка, если его нет. */
function fileExtension(filename) {
    const dot = filename.lastIndexOf('.');
    return dot > 0 ? filename.slice(dot).toLowerCase() : '';
}
/** Проверка имени, типа и размера до чтения содержимого. */
function checkAttachmentMetadata(input) {
    if (input.sizeBytes > contracts_1.ATTACHMENT_LIMITS.maxBytes) {
        const limitMb = Math.round(contracts_1.ATTACHMENT_LIMITS.maxBytes / 1024 / 1024);
        return {
            ok: false,
            reason: 'size',
            messageRu: `Файл больше ${limitMb} МБ. Загрузите файл меньшего размера или положите его во внешнее хранилище и добавьте ссылку.`,
        };
    }
    const extension = fileExtension(input.filename);
    if (!contracts_1.ATTACHMENT_LIMITS.allowedExtensions.includes(extension)) {
        return {
            ok: false,
            reason: 'extension',
            messageRu: extension
                ? `Файлы «${extension}» загружать нельзя. Разрешены изображения, PDF, документы Office, csv, json, md и zip.`
                : 'У файла нет расширения, определить его тип невозможно.',
        };
    }
    const mime = input.mimeType.split(';')[0].trim().toLowerCase();
    if (!contracts_1.ATTACHMENT_LIMITS.allowedMimeTypes.includes(mime)) {
        return {
            ok: false,
            reason: 'mime',
            messageRu: `Тип «${mime}» загружать нельзя. Разрешены изображения, PDF, документы Office, csv, json, md и zip.`,
        };
    }
    return { ok: true };
}
// --- Версии активов ------------------------------------------------------
exports.createAssetVersionSchema = zod_1.z
    .object({
    versionLabel: zod_1.z
        .string()
        .trim()
        .min(1, 'Обозначение версии обязательно')
        .max(80, 'Обозначение версии слишком длинное'),
    changeSummary: zod_1.z.string().trim().max(2000).optional().nullable(),
    /** Файл версии: уже загруженное вложение этого же элемента. */
    attachmentId: common_1.uuidSchema.optional().nullable(),
    externalUrl: zod_1.z.string().trim().url('Укажите корректную ссылку').max(2000).optional().nullable(),
    /** Сделать эту версию текущей. По умолчанию да: обычно новая версия и есть текущая. */
    makeCurrent: zod_1.z.boolean().default(true),
})
    .refine((value) => Boolean(value.attachmentId) || Boolean(value.externalUrl), {
    message: 'У версии должен быть файл или внешняя ссылка',
    path: ['attachmentId'],
});
exports.updateAssetVersionSchema = zod_1.z.object({
    changeSummary: zod_1.z.string().trim().max(2000).optional().nullable(),
    makeCurrent: zod_1.z.boolean().optional(),
});
// --- Проверка материалов -------------------------------------------------
exports.createReviewSchema = zod_1.z.object({
    decision: zod_1.z.enum(contracts_1.REVIEW_DECISIONS),
    commentMd: common_1.markdownSchema
        .max(20_000, 'Комментарий слишком длинный')
        .optional()
        .nullable()
        .transform((value) => (value && value.trim().length > 0 ? value.trim() : null)),
});
//# sourceMappingURL=assets.js.map